const addOns = {
    premiumAudienceScore: [
        {
            value: 'AUDIENCE_SCORE_MINIMUM',
            label: 'Premium Audience Score',
            id: 'premiumAudienceScore',
            icon: 'faCheck',
            description: 'Content creator must have an audience score higher than 80. Learn more about Premium Authenticity here (link to blog post)'
        }
    ],
    minimumAge21: [
        {
            value: 'AGE_MINIMUM',
            label: '21+ Required',
            id: 'minimumAge21',
            icon: 'faCheck',
            description: 'Content creator must be 21 years or older'
        }
    ],
    conquestingCreators: [
        {
            value: 'conquesting_creators',
            label: 'Conquesting Creators ',
            id: 'conquestingCreators',
            icon: 'faCheck',
            description: 'Activate creators that have worked with your competitors.'
        }
    ],
    excludeCreators: [
        {
            value: 'exclude_creators',
            label: 'Exclude Competitor Creators ',
            id: 'excludeCreators',
            icon: 'faCheck',
            description: 'Exclude creators that have worked with your competitors.'
        }
    ]
};

const contentFormatOptions = [
    {
        label: 'Instagram Stories',
        value: 'format_instagram_stories',
        id: 'format_instagram_stories',
        formats: ['VIDEO'],
        channel: ['social_channel_instagram'],
        sizes: [
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait 9:16',
                    assetUri: 'https://media.graphcms.com/9yk0YlwKQaSuzLIDrE5J',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            }
        ]
    },
    {
        label: 'Instagram In-Feed Image',
        value: 'format_instagram_in_feed_image',
        id: 'format_instagram_in_feed_image',
        formats: ['IMAGE'],
        channel: ['social_channel_instagram'],
        sizes: [
            {
                label: 'Portrait - 4:5',
                value: 'size_portrait_4_5',
                preview: {
                    title: 'Portrait 4:5',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/ljSlmdXfRBmQ27XkGlUM',
                    assetType: 'IMAGE',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square - 1:1',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/gzEJoQuGQpqCf9V7LEB7',
                    assetType: 'IMAGE',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Landscape - 16:9',
                value: 'size_landscape_16_9',
                preview: {
                    title: 'Landscape 16:9',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/CkAMyVqBTT2e9JwXrWc9',
                    assetType: 'IMAGE',
                    aspectRatio: 'landscape'
                }
            }
        ]
    },
    {
        label: 'Instagram In-Feed Video',
        value: 'format_instagram_in_feed_video',
        id: 'format_instagram_in_feed_video',
        formats: ['VIDEO'],
        channel: ['social_channel_instagram'],
        sizes: [
            {
                label: 'Portrait - 4:5',
                value: 'size_portrait_4_5',
                preview: {
                    title: 'Portrait 4:5',
                    assetUri: 'https://media.graphcms.com/LxaQDgWQD2p4ySvSFUbt',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/6MnpZrzmRwSPPtJnanTc',
                    assetType: 'VIDEO',
                    aspectRatio: 'square'
                }
            },
            { label: 'Landscape - 16:9', value: 'size_landscape_16_9' }
        ]
    },
    {
        label: 'Facebook Stories',
        value: 'format_facebook_stories',
        id: 'format_facebook_stories',
        formats: ['VIDEO'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait 9:16',
                    assetUri: 'https://media.graphcms.com/g00aLswQWiqCxtU60UOO',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            }
        ]
    },
    {
        label: 'Facebook In-Feed Image',
        value: 'format_facebook_in_feed_image',
        id: 'format_facebook_in_feed_image',
        formats: ['IMAGE'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 2:3',
                value: 'size_portrait_2_3',
                preview: {
                    title: 'Portrait 2:3',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/4Modt45ZRIaneFFDq7gQ',
                    assetType: 'IMAGE',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Portrait - 4:5',
                value: 'size_portrait_4_5',
                preview: {
                    title: 'Portrait 4:5',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/7Man2nWJSNuDPX2C7kMI',
                    assetType: 'IMAGE',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait 9:16',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/wdXvjH4QuepGcupZp1vA',
                    assetType: 'IMAGE',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/aH9ks65TpuXahlsBOKmw',
                    assetType: 'IMAGE',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Landscape - 16:9',
                value: 'size_landscape_16_9',
                preview: {
                    title: 'Landscape 16:9',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/Z12pqEwKTzep5ETbYHGp',
                    assetType: 'IMAGE',
                    aspectRatio: 'horizontal'
                }
            }
        ]
    },
    {
        label: 'Facebook In-Feed Video',
        value: 'format_facebook_in_feed_video',
        id: 'format_facebook_in_feed_video',
        formats: ['VIDEO'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 4:5',
                value: 'size_portrait_4_5',
                preview: {
                    title: 'Portrait 4:5',
                    assetUri: 'https://media.graphcms.com/reFc6NMVSkSCGhBaNicn',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Portrait - 2:3',
                value: 'size_portrait_2_3',
                preview: {
                    title: 'Portrait 2:3',
                    assetUri: 'https://media.graphcms.com/DZ4pTusWQYyAtgRRmx0d',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait 9:16',
                    assetUri: 'https://media.graphcms.com/YZmdHms1RWR9q20rxkbg',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/c27qqZMETbShuEZY12j8',
                    assetType: 'VIDEO',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Landscape - 16:9',
                value: 'size_landscape_16_9',
                preview: {
                    title: 'Landscape 16:9',
                    assetUri: 'https://media.graphcms.com/Abn264TmRyW00xCWK5Tg',
                    assetType: 'VIDEO',
                    aspectRatio: 'landscape'
                }
            }
        ]
    },
    {
        label: 'Snapchat Snap Ad',
        value: 'format_snapchat_snap_ad',
        id: 'format_snapchat_snap_ad',
        formats: ['VIDEO'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait - 9:16',
                    assetUri: 'https://media.graphcms.com/3QsGO83XSTu0pKkTAWdQ',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            }
        ]
    },
    {
        label: 'Snapchat Stories',
        value: 'format_snapchat_stories',
        id: 'format_snapchat_stories',
        formats: ['VIDEO'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait 9:16',
                    assetUri: 'https://media.graphcms.com/76Dw5tIERAST9aqHu4hb',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            }
        ]
    },
    {
        label: 'TikTok In-Feed',
        value: 'format_tiktok_in_feed',
        id: 'format_tiktok_in_feed',
        formats: ['VIDEO'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait 9:16',
                    assetUri: 'https://media.graphcms.com/5sZA66WT5KpMlhP5FfCg',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            }
        ]
    },
    {
        label: 'Twitter Promoted Video',
        value: 'format_twitter_promoted_video',
        id: 'format_twitter_promoted_video',
        formats: ['VIDEO'],
        channel: ['social_channel_twitter'],
        sizes: [
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/QAkNvJCQu66srqZMdLTE',
                    assetType: 'VIDEO',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Landscape - 16:9',
                value: 'size_landscape_16_9',
                preview: {
                    title: 'Landscape 16:9',
                    assetUri: 'https://media.graphcms.com/vz9psIxWRrSOTBPVbf2y',
                    assetType: 'VIDEO',
                    aspectRatio: 'horizontal'
                }
            }
        ]
    },
    {
        label: 'Twitter Promoted Image',
        value: 'format_twitter_promoted_image',
        id: 'format_twitter_promoted_image',
        formats: ['IMAGE'],
        channel: ['social_channel_twitter'],
        sizes: [
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/dhwB382oTY2YMfmB1C7Q',
                    assetType: 'IMAGE',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Landscape - 16:9',
                value: 'size_landscape_16_9',
                preview: {
                    title: 'Landscape 16:9',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/E8YHN8NuTPaEnGHVCOTm',
                    assetType: 'IMAGE',
                    aspectRatio: 'horizontal'
                }
            }
        ]
    },
    {
        label: 'Pinterest Video Pin',
        value: 'format_pinterest_video_pin',
        id: 'format_pinterest_video_pin',
        formats: ['VIDEO'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/hpX39QAQKCdTxWBmywXz',
                    assetType: 'VIDEO',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Portrait - 2:3',
                value: 'size_portrait_2_3',
                preview: {
                    title: 'Portrait 2:3',
                    assetUri: 'https://media.graphcms.com/UChue1YLQiumOuCsGu6g',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            }
        ]
    },
    {
        label: 'Youtube Video',
        value: 'format_youtube_video',
        id: 'format_youtube_video',
        formats: ['VIDEO'],
        channel: ['social_channel_youtube'],
        sizes: [
            {
                label: 'Portrait - 9:16',
                value: 'size_portrait_9_16',
                preview: {
                    title: 'Portrait 9:16',
                    assetUri: 'https://media.graphcms.com/zh3CIdvVQwadG1OPbUuJ',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Landscape - 16:9',
                value: 'size_landscape_16_9',
                preview: {
                    title: 'Landscape 16:9',
                    assetUri: 'https://media.graphcms.com/mbLQeICiT9yBa5KRSReF',
                    assetType: 'VIDEO',
                    aspectRatio: 'horizontal'
                }
            }
        ]
    },
    {
        label: 'Google Video',
        value: 'format_google_video',
        id: 'format_google_video',
        formats: ['VIDEO'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 2:3',
                value: 'size_portrait_2_3',
                preview: {
                    title: 'Portrait 2:3',
                    assetUri: 'https://media.graphcms.com/1DVYDM5URa6GNDM4L5Jp',
                    assetType: 'VIDEO',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/GK6UtSYRZS8m1vEWq3mf',
                    assetType: 'VIDEO',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Landscape - 16:9',
                value: 'size_landscape_16_9',
                preview: {
                    title: 'Landscape 16:9',
                    assetUri: 'https://media.graphcms.com/w10hCoVnQxqWzA5bExjW',
                    assetType: 'VIDEO',
                    aspectRatio: 'horizontal'
                }
            }
        ]
    },
    {
        label: 'Google Image',
        value: 'format_google_image',
        id: 'format_google_image',
        formats: ['IMAGE'],
        channel: ['social_channel_other'],
        sizes: [
            {
                label: 'Portrait - 2:3',
                value: 'size_portrait_2_3',
                preview: {
                    title: 'Portrait 2:3',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/jbUzHvq1TjGGrZIStOEC',
                    assetType: 'IMAGE',
                    aspectRatio: 'vertical'
                }
            },
            {
                label: 'Square - 1:1',
                value: 'size_square_1_1',
                preview: {
                    title: 'Square 1:1',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/iEs63gHATJuCOLaT5a5O',
                    assetType: 'IMAGE',
                    aspectRatio: 'square'
                }
            },
            {
                label: 'Landscape - 1.91:1',
                value: 'size_landscape_1_91_1',
                preview: {
                    title: 'Landscape 1.91:1',
                    assetUri: 'https://media.graphcms.com/resize=fit:max,height:800,width:640/xSwY0PAgTr2ec10Ymp5L',
                    assetType: 'IMAGE',
                    aspectRatio: 'horizontal'
                }
            }
        ]
    }
];

const contentTierBaseOptions = [
    {
        label: 'UGC',
        value: 'content_tier_ugc',
        id: 'content_tier_ugc'
    },
    {
        label: 'PRO',
        value: 'content_tier_pro',
        id: 'content_tier_pro'
    }
];

const contentUseBaseOptions = [
    {
        label: 'Social',
        value: 'content_usage_social',
        id: 'content_usage_social'
    },
    {
        label: 'Digital Media',
        value: 'content_usage_digital_media',
        id: 'content_usage_digital_media'
    },
    {
        label: 'Website',
        value: 'content_usage_website',
        id: 'content_usage_website'
    },
    {
        label: 'Ecommerce',
        value: 'content_usage_ecommerce',
        id: 'content_usage_ecommerce'
    },
    {
        label: 'TV',
        value: 'content_usage_tv',
        id: 'content_usage_tv'
    },
    {
        label: 'Packaging',
        value: 'content_usage_packaging',
        id: 'content_usage_packaging'
    },
    {
        label: 'Cloud',
        value: 'content_usage_cloud',
        id: 'content_usage_cloud'
    },
    {
        label: 'Email',
        value: 'content_usage_email',
        id: 'content_usage_email'
    },
    {
        label: 'Other',
        value: 'content_usage_other',
        id: 'content_usage_other'
    }
];
const contentReuseBaseOptions = [
    {
        label: 'Social',
        value: 'content_reuse_social',
        id: 'content_reuse_social'
    },
    {
        label: 'Digital Media',
        value: 'content_reuse_digital_media',
        id: 'content_reuse_digital_media'
    },
    {
        label: 'Website',
        value: 'content_reuse_website',
        id: 'content_reuse_website'
    },
    {
        label: 'Ecommerce',
        value: 'content_reuse_ecommerce',
        id: 'content_reuse_ecommerce'
    },
    {
        label: 'TV',
        value: 'content_reuse_tv',
        id: 'content_reuse_tv'
    },
    {
        label: 'Packaging',
        value: 'content_reuse_packaging',
        id: 'content_reuse_packaging'
    },
    {
        label: 'Cloud',
        value: 'content_reuse_cloud',
        id: 'content_reuse_cloud'
    },
    {
        label: 'Email',
        value: 'content_reuse_email',
        id: 'content_reuse_email'
    },
    {
        label: 'None',
        value: 'content_reuse_none',
        id: 'content_reuse_none'
    },
    {
        label: 'Other',
        value: 'content_reuse_other',
        id: 'content_reuse_other'
    }
];

const socialChannelBaseOptions = [
    {
        label: 'Instagram',
        value: 'social_channel_instagram',
        id: 'social_channel_instagram'
    },
    {
        label: 'Twitter',
        value: 'social_channel_twitter',
        id: 'social_channel_twitter'
    },
    {
        label: 'YouTube',
        value: 'social_channel_youtube',
        id: 'social_channel_youtube'
    },
    {
        label: 'TikTok',
        value: 'social_channel_tiktok',
        id: 'social_channel_tiktok'
    },
    {
        label: 'Other',
        value: 'social_channel_other',
        id: 'social_channel_other'
    }
];

const videoKindBaseOptions = [
    {
        label: 'Std. In-Feed',
        value: 'video_kind_standard_in_feed',
        id: 'video_kind_standard_in_feed'
    },
    {
        label: 'Boomerang',
        value: 'video_kind_boomerang',
        id: 'video_kind_boomerang'
    },
    {
        label: 'Stories',
        value: 'video_kind_stories',
        id: 'video_kind_stories'
    },
    {
        label: 'Stop Motion',
        value: 'video_kind_stop_motion',
        id: 'video_kind_stop_motion'
    },
    {
        label: 'Adv. Motion',
        value: 'video_kind_advanced_motion',
        id: 'video_kind_advanced_motion'
    },
    {
        label: 'Narrative',
        value: 'video_kind_narrative',
        id: 'video_kind_narrative'
    },
    {
        label: 'Tutorial',
        value: 'video_kind_tutorials',
        id: 'video_kind_tutorials'
    }
];

export { addOns, contentFormatOptions, contentReuseBaseOptions, contentTierBaseOptions, contentUseBaseOptions, socialChannelBaseOptions, videoKindBaseOptions };



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/@social-native/snpkg-client-data-to-views/dist/index.es.js
// module id = 2719
// module chunks = 69